import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';
import { SessionStorage } from '@alfa-bank/site-helpers-common/browser/session-storage';

import { DEFAULT_CITY_MESSAGE } from './city';

import { getMaxLengthValidator } from '.';

export interface IDeliveryCity {
    addrType?: string;
    districtName?: string;
    extendedName?: string;
    kladrId?: string;
    name?: string;
    regionName?: string;
}

// логика валидации поля с городом по продукту RKO
export const isValidDeliveryCity = (value?: string): boolean => {
    if (!value) {
        return false;
    }
    const sessionStorage = new SessionStorage({ id: 'deliveryCitiesRKO' });
    const cities = sessionStorage.get('deliveryCitiesRKO');
    let cityExists = 0;

    if (cities) {
        cityExists = (cities as IDeliveryCity[]).filter(
            ({ extendedName }) => extendedName?.toLowerCase() === value.toLowerCase()
        ).length;
    }

    return Boolean(cityExists);
};

export const validateDeliveryCityValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidDeliveryCity(value), DEFAULT_CITY_MESSAGE, customMessage);

export const validateDeliveryCity = (message?: string) =>
    composeValidators(getMaxLengthValidator(50), validateDeliveryCityValue(message));
